
@if (loadingSignal()) {
  <div class="spinner-container">
    @if (brandPrimaryColor()) {
      <div
        class="spinner-image"
        role="img"
        aria-label="Loading"
        [ngStyle]="{
          'background-color': brandPrimaryColor(),
          '-webkit-mask-image': 'url(' + spinnerUrl + ')',
          'mask-image': 'url(' + spinnerUrl + ')'
        }"
      ></div>
    }
  </div>
}
